import React from 'react';
import { Box, Grid, Skeleton } from 'housecall-ui';

import { Footer } from './Footer';

export const FormSkeleton = () => {
  return (
    <Box pt={1}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Skeleton variant="rect" width="40%" height={30} aria-label="Loading" role="status" aria-live="polite" />
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="rect" width="80%" height={30} aria-label="Loading" role="status" aria-live="polite" />
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="rect" height={56} aria-label="Loading" role="status" aria-live="polite" />
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="rect" height={56} aria-label="Loading" role="status" aria-live="polite" />
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="rect" height={56} aria-label="Loading" role="status" aria-live="polite" />
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="rect" height={72} aria-label="Loading" role="status" aria-live="polite" />
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="rect" height={40} aria-label="Loading" role="status" aria-live="polite" />
        </Grid>
        <Grid item xs={12}>
          <Footer />
        </Grid>
      </Grid>
    </Box>
  );
};
